// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const AddressVerificationState = {
  Unverified: {
    Name: 'Unverified',
    Value: 'unverified',
    Label: 'Unverified',
    Icon: 'CircleAlert',
    Variant: 'destructive',
  },
  ManuallyVerified: {
    Name: 'Manually Verified',
    Value: 'manually_verified',
    Label: 'Manually Verified',
    Icon: 'CircleQuestionMark',
    Variant: 'brand',
  },
  VerifiedApproximate: {
    Name: 'Verified Approximate',
    Value: 'verified_approximate',
    Label: 'Verified (Approximate)',
    Icon: 'MapPinCheckInside',
    Variant: 'warning',
  },
  Verified: {
    Name: 'Verified',
    Value: 'verified',
    Label: 'Verified',
    Icon: 'MapPinCheckInside',
    Variant: 'success',
  },
} as const

export type AddressVerificationStateValue =
  (typeof AddressVerificationState)[keyof typeof AddressVerificationState]['Value']
